import cls from 'classnames';
import { FieldProps, getIn } from 'formik';
import * as React from 'react';

const styles = require('./InputText.scss');

export interface Props extends FieldProps {
    label: string;
    type: 'text' | 'number';
    hideErrors?: boolean;
    hideLabel?: boolean;
    indicator?: string; // status indicator, shows below the bar if no errors are present
    mask?: string;
    onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>;
    onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>;
}

export class FormikTextInput extends React.Component<Props> {
    input: HTMLInputElement | null;

    /**
     * Reinitialize the input mask if one is specified. We need to
     * do this once after every render. Note: we can't do this in render because
     * the input ref is not defined.
     */
    initMask() {
        // Need to put this require here because for some reason SSR doesn't like this lib...
        const InputMask = require('inputmask');

        if (!this.props.mask || !this.input) {
            return;
        }

        const mask = new InputMask({ mask: this.props.mask, showMaskOnHover: false });
        mask.mask(this.input);
    }

    componentDidMount() {
        this.initMask();
    }

    componentDidUpdate() {
        this.initMask();
    }

    render() {
        const {
            field,
            form: { errors, touched },
            label,
            type,
            hideErrors,
            hideLabel,
            indicator,
            ...props
        } = this.props;

        const showError = !hideErrors && getIn(errors, field.name) && getIn(touched, field.name);

        return (
            <div className={styles.className}>
                <input
                    ref={(ref) => (this.input = ref)}
                    type={type || 'text'}
                    className={cls(styles.input, { [styles.hasError]: showError })}
                    {...field}
                    {...props}
                    autoComplete='new-password'
                    value={field.value || ''}
                />

                <div className={styles.bar} />

                {!hideLabel && <label className={cls(styles.label, { [styles.labelActive]: !!field.value })}>{label}</label>}

                {showError && <div className={styles.error}>{getIn(errors, field.name)}</div>}

                {!showError && !!indicator && <label className={styles.statusIndicator}>{indicator}</label>}
            </div>
        );
    }
}

export default FormikTextInput;
